import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createBlock(_component_BaseSubHeading, {
    size: "extra-small",
    weight: "600",
    className: "story-point"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.storyPoint), 1)
    ]),
    _: 1
  }))
}